import { createWithContextAndReduxStateHOC, createWithContextStateHOC } from 'contexts/support/withContextStateHOC'
import { GlobalSearchStateContext } from './GlobalSearchContexts'
import GlobalSearchState from './GlobalSearchState'

const withGlobalSearchState = createWithContextStateHOC<GlobalSearchState>(GlobalSearchStateContext, 'withGlobalSearchContext')

export default withGlobalSearchState

export const withGlobalSearchStateAndRedux = createWithContextAndReduxStateHOC<GlobalSearchState>(GlobalSearchStateContext, 'withGlobalSearchContext')
